import { ContentHeader } from '../../components/layout/ContentHeader'
import { ComingSoon } from '../../components/ui/ComingSoon'
import { useParams } from 'react-router-dom'

export default function AuditResources() {
  const { projectId } = useParams<{ projectId: string }>()
  return (
    <>
      <ContentHeader breadcrumb={[{ label: 'Audit de site Web', to: `/p/${projectId}/audit` }, { label: 'Ressources trouvees' }]} title="Ressources trouvees" />
      <ComingSoon title="Ressources trouvees" description="L'analyse des images, scripts et feuilles de style avec leurs poids et codes HTTP arrive bientot." />
    </>
  )
}
